import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import View from './view';

/**
 * @params {any} props
 */
const ListWithDetails = (props) => {
  const { onSelect } = props;

  const navigateTo = useRef();
  const [internalSelectedItem, setInternalSelectedItem] = useState(props.initialItem);
  // Selection is controlled when the parent passes `selectedItem` (may be null for "none")
  const isControlled = props.selectedItem !== undefined;
  const selectedItem = isControlled ? props.selectedItem : internalSelectedItem;

  function selectItem(item) {
    const idField = props.idField || 'id';
    if (props.onClick) props.onClick(item);
    if (!isControlled) {
      setInternalSelectedItem(item[idField]);
    }
    navigateTo.current?.(1);
    onSelect?.(item);
  }

  return (
    <View {...props} selectedItem={selectedItem} selectItem={selectItem} navigateTo={navigateTo} />
  );
};

ListWithDetails.propTypes = {
  items: PropTypes.array.isRequired,
  renderBadge: PropTypes.func.isRequired,
  renderDetails: PropTypes.func.isRequired,
  overrideDetails: PropTypes.element,
  title: PropTypes.string,
  onClick: PropTypes.func,
  addButton: PropTypes.element,
  loading: PropTypes.bool,
  idField: PropTypes.string,
  initialItem: PropTypes.object,
  selectedItem: PropTypes.any,
};

export default ListWithDetails;
